var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5354_11470",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#155DFC",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V1H30V0V-1H10V0ZM40 10H39V30H40H41V10H40ZM30 40V39H10V40V41H30V40ZM0 30H1V10H0H-1V30H0ZM10 40V39C5.02944 39 1 34.9706 1 30H0H-1C-1 36.0751 3.92487 41 10 41V40ZM40 30H39C39 34.9706 34.9706 39 30 39V40V41C36.0751 41 41 36.0751 41 30H40ZM30 0V1C34.9706 1 39 5.02944 39 10H40H41C41 3.92487 36.0751 -1 30 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z",
    fill: "#2B7FFF",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_5354_11470)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 21.6662C13.1755 21.6668 13.0209 21.6226 12.8874 21.5387C12.7538 21.4549 12.6468 21.3349 12.5787 21.1926C12.5106 21.0504 12.4843 20.8917 12.5028 20.7351C12.5213 20.5785 12.5839 20.4304 12.6832 20.3079L20.9332 11.8079C20.9951 11.7365 21.0795 11.6882 21.1724 11.671C21.2653 11.6538 21.3613 11.6687 21.4447 11.7133C21.528 11.7579 21.5937 11.8295 21.631 11.9163C21.6683 12.0032 21.675 12.1001 21.6499 12.1912L20.0499 17.2079C20.0027 17.3342 19.9869 17.47 20.0037 17.6037C20.0206 17.7375 20.0696 17.8651 20.1467 17.9758C20.2237 18.0864 20.3264 18.1767 20.446 18.2389C20.5656 18.3011 20.6984 18.3333 20.8332 18.3329H26.6666C26.8243 18.3324 26.9789 18.3766 27.1124 18.4604C27.246 18.5443 27.3531 18.6643 27.4211 18.8065C27.4892 18.9488 27.5155 19.1074 27.497 19.264C27.4785 19.4206 27.4159 19.5688 27.3166 19.6912L19.0666 28.1912C19.0047 28.2627 18.9204 28.3109 18.8274 28.3281C18.7345 28.3453 18.6385 28.3304 18.5551 28.2858C18.4718 28.2412 18.4061 28.1697 18.3688 28.0828C18.3315 27.996 18.3248 27.899 18.3499 27.8079L19.9499 22.7912C19.9971 22.665 20.0129 22.5291 19.9961 22.3954C19.9792 22.2617 19.9302 22.134 19.8532 22.0234C19.7761 21.9128 19.6734 21.8225 19.5538 21.7603C19.4343 21.6981 19.3014 21.6658 19.1666 21.6662H13.3332Z",
    stroke: "#8EC5FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteVector);
export default __webpack_public_path__ + "static/media/complete-vector.4ddb69ec724805284aded7a9506e2832.svg";
export { ForwardRef as ReactComponent };